export default function () {

    let audioEl = document.querySelectorAll('.Audio');
    let audioElCount = audioEl.length;

    for (let i = 0; i < audioElCount; i++) {
        buildAudioPlayer(i);
    }

    function toHHMMSS(secs) {
        var sec_num = parseInt(secs, 10)
        var hours = Math.floor(sec_num / 3600) % 24
        var minutes = Math.floor(sec_num / 60) % 60
        var seconds = sec_num % 60
        return [hours, minutes, seconds]
            .map(v => v < 10 ? "0" + v : v)
            .filter((v, i) => v !== "00" || i > 0)
            .join(":")
    }

    function formatTime(time, el) {
        var timeString = toHHMMSS(time);
        el.innerHTML = timeString;
    }

    function stopOtherPlayers() {
        let currPlaying = document.querySelectorAll('.audio-playPause.is-pause');
        for (let i = 0; i < currPlaying.length; i++) {
            currPlaying[i].click();
        }
    }

    function buildAudioPlayer(player) {
        let audioPlayer = document.querySelectorAll('.Audio-player')[player];
        let audio = audioPlayer.querySelector('audio');
        let audioTrack = audio.querySelector('source');
        let playPause = audioPlayer.querySelector('.audio-playPause');
        let speed = audioPlayer.querySelector('.audio-speed');

        let durationEl = audioPlayer.querySelector('.audio-duration');
        let currTimeEl = audioPlayer.querySelector('.audio-currentTime');
        let progressEl = audioPlayer.querySelector('.audio-progress');
        let volumeEl = audioPlayer.querySelector('.audio-volume');
        let volumeToggleEl = audioPlayer.querySelector('.audio-volumeToggle');
        let waveEl = audioPlayer.querySelector('.Wave');

        var isPlaying;
        var audioDuration;

        function init() {
            audioDuration = Math.round(audio.duration);
            let currTime = Math.round(audio.currentTime);

            if (isNaN(audioDuration)) {
                handleAudioError(audioPlayer);
                return;
            }

            console.log('audioDuration:', audioDuration);

            formatTime(audioDuration, durationEl);
            formatTime(currTime, currTimeEl);

            progressEl.setAttribute('max', audioDuration);
        };

        window.addEventListener('load', function () {
            audio.addEventListener('canplay', init());
        });

        progressEl.oninput = function () {
            audio.currentTime = this.value;
        };

        volumeEl.oninput = function () {
            audio.volume = (this.value / 100);
        };

        function handleAudioError(audioPlayer) {
            console.log('hanlding error');
            let errorEl = document.createElement('div');
            errorEl.classList.add('Audio-error')
            errorEl.innerHTML = '<p class="u-textCenter">Error Loading Audio: Please try again later.</p>'
            audioPlayer.insertBefore(errorEl, audioPlayer.childNodes[0]);
        }

        audio.ontimeupdate = function () {
            let currTime = Math.round(audio.currentTime);
            formatTime(currTime, currTimeEl);
            progressEl.value = currTime;
        };

        audio.onended = function () {
            audio.pause();
            playPause.classList.remove('is-pause');
            playPause.classList.add('is-play');
            waveEl.classList.remove('is-animating');
            audio.currentTime = 0;
        };

        volumeToggleEl.addEventListener('click', function () {
            this.classList.toggle('is-muted');
            if (this.classList.contains('is-muted')) {
                audio.volume = 0;
            } else {
                audio.volume = 1;
            }
        });

        playPause.addEventListener('click', function (e) {
            isPlaying = !audio.paused;
            this.classList.remove('is-play');
            this.classList.remove('is-pause');
            waveEl.classList.remove('is-animating');
            if (isPlaying) {
                audio.pause();
                this.classList.add('is-play');
            } else {
                stopOtherPlayers();
                audio.play();
                this.classList.add('is-pause');
                waveEl.classList.add('is-animating');
            }
        });

        speed.addEventListener('click', function (e) {
            let currSpeed = audio.playbackRate;
            console.log('speed: ', currSpeed);
            let newSpeed = 0;
            if (currSpeed === 1) {
                newSpeed = 1.5;
            } else if (currSpeed === 1.5) {
                newSpeed = 2;
            } else if (currSpeed === 2) {
                newSpeed = .5;
            } else {
                newSpeed = 1;
            }
            audio.playbackRate = newSpeed;
            speed.innerHTML = `${newSpeed}x`;
        });
    }

}